var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ height: "512", viewBox: "0 0 64 64", width: "512", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M54 8H10a2 2 0 0 0 0 4h44a2 2 0 0 0 0-4zM54 52H10a2 2 0 0 0 0 4h44a2 2 0 0 0 0-4zM10 23h28a2 2 0 0 0 0-4H10a2 2 0 0 0 0 4zM54 30H10a2 2 0 0 0 0 4h44a2 2 0 0 0 0-4zM10 45h28a2 2 0 0 0 0-4H10a2 2 0 0 0 0 4z" })
  );
});